module.exports = __webpack_public_path__ + "img/n1.78602230.svg";